import React, { useEffect } from "react";
import OnboardingScreenTactical from "./OnboardingScreenTactical";
import { redirectLoaded, delay } from "../../utils";
import { EventLogger } from "../../common/utils/EventLogger";

function SevenElevenTacticalMain() {
  useEffect(() => {
    const initialize = async () => {
      try {
        await EventLogger.logInfoEvent("7-Eleven tactical main component initializing", {});
        await delay(100);
      } catch (error) {
        console.warn("Error during 7-Eleven tactical main initialization:", error);
      } finally {
        redirectLoaded();
      }
    };

    initialize();
  }, []);

  return <OnboardingScreenTactical />;
}

export default SevenElevenTacticalMain;
